<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8" class="mt-10">
        <v-alert
          border="bottom"
          colored-border
          type="warning"
          elevation="2"
        >Hi there, polite notice. Your account is inactive. Please activate or contact administrator</v-alert>
      </v-col>

      <!-- <v-col cols="12" md="7" v-if="(role == 3)">
        <span><b>Your Bill:</b></span> <span style="color: red"><b>{{bill.toLocaleString()}}</b></span>
        <h3>E-Wallet Top Up</h3>

        <div class="mt-2">1. Go to M-PESA on your phone</div>
        <div class="mt-2">2. Select Lipa Na M-PESA -> Pay Bill</div>
        <div class="mt-2">
          3. Enter Business No:
          <b>4097183</b>
        </div>
        <div class="mt-2">
          4. Enter Account No:
          <b>SP703</b>
        </div>
        <div class="mt-2">5. Enter the amount you want to top up</div>
        <div class="mt-2">6. Enter your M-PESA PIN and send</div>
        <div class="mt-2">7. You will receive Confirmation sms from M-PESA</div>
        <div class="mt-2" style="color: blue"><b>Once you receive payment sms please refresh to access account</b></div>
        <div>
          <v-btn color="accent" @click="refreshPage">Refresh</v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="7" v-else>
        <h3>Account Details</h3>
        <div class="mt-2">
          Business No:
          <b>4097183</b>
        </div>
        <div class="mt-2">
          Account No:
          <b>SP703</b>
        </div>
        <div>
          <v-btn color="accent" @click="refreshPage">Refresh</v-btn>
        </div>
      </v-col> -->

    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    role() {
      return localStorage.getItem("userRole");
    },
  },
  data: () => ({
    search: "",
    eWalletBalance: null,
    SmsBalance: null,
    CardCode: null,
    bill: null,
    headers: [
      { text: "Name", value: "name" },
      { text: "Email", value: "email" },
      { text: "Account Expiry Date", value: "trial_until" },
      { text: "Action", value: "action" }
    ],
    subscribers: []
  }),
  methods: {
    refreshPage() {
      location.reload();
    },
    getSubscribers() {
      const self = this;
      this.$store
        .dispatch("get", `/get-subscribers`)
        .then(res => {
          self.subscribers = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/accounts`)
        .then(res => {
          if (res.ResultCode == 310) {
            self.$router.push("/inactive-account");
          } else {
            self.$router.push("/pos");
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.eWalletBalance = res.ResponseData.EWalletBalance;
            self.SmsBalance = res.ResponseData.SmsBalance;
            self.CardCode = res.ResponseData.CardCode;
            self.bill = res.ResponseData.SubscriptionFee;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    checkExpiry() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResponseData.SystemSuspended == 0) {
            self.$router.push("/switch-store");
          }
        })
        .catch(() => { });
    },
  },
  created() {
    this.checkExpiry();
    this.getSubscribers();
    // this.getAccounts();
    // this.getGenSettings();
  }
};
</script>